module.exports = __webpack_public_path__ + "static/media/logo-nexios.ccd96498.svg";